module.exports = __webpack_public_path__ + "img/solar-panel-white.903330fe.svg";